import { apiSlice } from "./apiSlice";
import { APP_VERSION_URL } from "../constants";

const appVersionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Latest released versions of the gym-admin app for one platform.
    getGymAdminAppVersions: builder.mutation({
      query: (data) => ({
        url: `${APP_VERSION_URL}`,
        method: "POST",
        body: { platform: data.platform },
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const { useGetGymAdminAppVersionsMutation } = appVersionApiSlice;
